export class Page {
  currentPage: number;
  nextPage: number;
  previousPage: number;
  size: number;
  totalElements: number;
  totalPage: number;
}
